import styled from 'styled-components';

export const Element = styled.section`
  display: flex;
  min-height: 100vh;
  font-family: 'Nunito', sans-serif;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  position: relative;
  padding: 2rem;
  color: white;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 80%, rgba(244, 241, 222, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(244, 241, 222, 0.08) 0%, transparent 50%);
    pointer-events: none;
  }

  @media (max-width: 768px) {
    order: -1;
    min-height: 25vh;
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    min-height: 20vh;
    padding: 1rem;
  }
`;

export const RightColumn = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 25%, #dee2e6 50%, #ced4da 75%, #adb5bd 100%);
  position: relative;
  padding: 2rem;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(circle at 20% 80%, rgba(26, 26, 46, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(244, 241, 222, 0.06) 0%, transparent 50%),
      radial-gradient(circle at 40% 40%, rgba(26, 26, 46, 0.05) 0%, transparent 50%);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      repeating-linear-gradient(
        45deg,
        transparent,
        transparent 4px,
        rgba(26, 26, 46, 0.02) 4px,
        rgba(26, 26, 46, 0.02) 6px
      );
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding: 1rem;
    align-items: flex-start;
    padding-top: 2rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
    padding-top: 1.5rem;
  }
`;
